<template>
  <div class="myinfo-course-box">
    <div class="search-box-1" v-if="!courseInformationVisible">
      <div class="search">
        <img :src="require('@/assets/icon/search.png')" />
        <el-input
          v-model="queryStr"
          placeholder="What do you want to learn？"
        ></el-input>
        <el-button @click.native="search">search</el-button>
      </div>

      <div class="icon-gray-button item-input_w25" @click="gotoAddCourse">
        <div>
          <img :src="require('@/assets/icon/course.png')" />
          <span>Add a course</span>
        </div>
        <i class="el-icon-circle-plus"></i>
      </div>
    </div>
    <div class="search-box" v-if="!courseInformationVisible">
      <div class="search-box-fliter-box">
        <div class="search-box-fliter">
          <el-popover
            placement="bottom-start"
            width="200"
            trigger="click"
            v-model="coursePopoverShow"
            popper-class="pc-filter-popover"
          >
            <div
              class="filter-btn-box"
              :class="{ 'select-filter': courseStatusLabelList.length > 0 }"
              slot="reference"
            >
              Course Status<span class="arrow-box"
                ><i
                  class="el-icon-arrow-down"
                  :class="[{ 'submenu-icon-arrow': coursePopoverShow }]"
                ></i
              ></span>
            </div>
            <el-checkbox-group v-model="courseStatusLabelList">
              <el-checkbox
                v-for="(item, index) in courseStatusList"
                :label="item.name"
                :key="index"
              ></el-checkbox>
            </el-checkbox-group>
            <div class="popover-footer">
              <el-button
                type="text"
                size="small"
                class="clear-bt"
                @click="clearFilterLabel(1)"
                >Clear All</el-button
              >
              <el-button size="small" class="apply-bt" @click="applyFilter(1)"
                >Apply</el-button
              >
            </div>
          </el-popover>
        </div>
        <div class="search-box-reset-box">
          <el-button class="reset-bt" size="small" @click="resetFilter(1)"
            >Reset</el-button
          >
        </div>
      </div>

      <div class="search-box-li" v-if="showFilterLabels">
        <div
          class="filters-wrapper"
          v-for="(item, index) in courseStatusLabelList"
          :key="index"
        >
          {{ item }}
        </div>
      </div>
    </div>
    <div class="myinfo-mid-content" v-if="!courseInformationVisible">
      <div class="list-head">
        <div class="flex_6">Course</div>
        <div class="flex_2">Type</div>
        <div class="flex_2">Price</div>
        <div class="flex_3">Status</div>
        <div class="flex_3">School</div>
        <div class="flex_3">Operate</div>
      </div>

      <div
        class="list-content"
        v-for="(item, index) in teacherCourseList"
        :key="index"
      >
        <div class="flex_6 info-box">
          <el-image class="info-img" :src="item.courseImg[0]">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <div style="width: 8px; height: 100%; display: inline-block"></div>
          <div class="info-detail">
            <div class="detail-title" :title="item.courseName">
              {{ item.courseName }}
            </div>
            <div class="detail-content" :title="item.courseDesc">
              {{ item.courseDesc }}
            </div>
            <!-- <div class="detail-id">Course No: {{item.courseNo}}</div> -->
            <div class="detail-id">ID: {{ item.id }}</div>
          </div>
        </div>
        <div class="flex_2">{{ item.covey_course_type.name }}</div>
        <div class="flex_2 operation">
          C$ {{ (item.price / 100).toFixed(2) }}
        </div>
        <div class="flex_3 flex-box">
          <i
            style="margin-right: 8px"
            :class="statusStrMap[item.status].icon"
            :style="{ color: statusStrMap[item.status].color }"
          ></i>
          {{ statusStrMap[item.status].name }}
        </div>

        <div class="flex_3 ellipsis1" :title="item.covey_school.name">
          {{ item.covey_school.name }}
        </div>
        <div class="flex_3 operation">
          <span v-if="item.status === 1" @click="teachCourse(item)">View</span>
          <span v-if="item.status === 1" style="color: #666666"
            >&nbsp;|&nbsp;</span
          >
          <span v-if="item.status === 1" @click="publishCourse(item)">Add</span>
          <span
            v-if="[-1, 0, 2].includes(item.status)"
            @click="editCourse(item)"
            >Edit
          </span>
        </div>
      </div>
      <div v-if="teacherCourseList.length < 5">
        <div
          class="list-content"
          v-for="index in 5 - teacherCourseList.length"
          :key="index"
        >
          <div class="flex_6"></div>
          <div class="flex_2"></div>
          <div class="flex_2"></div>
          <div class="flex_3"></div>
          <div class="flex_3"></div>
        </div>
      </div>
    </div>
    <div class="search-box search-box-2" v-if="courseInformationVisible">
      <div class="search-box-fliter-box">
        <div class="search-box-fliter">
          <el-popover
            placement="bottom-start"
            width="220"
            trigger="click"
            v-model="childCoursePopoverShow"
            popper-class="pc-filter-popover"
          >
            <div
              class="filter-btn-box"
              :class="{
                'select-filter': childCourseStatusLabelList.length > 0,
              }"
              slot="reference"
            >
              Course Status<span class="arrow-box"
                ><i
                  class="el-icon-arrow-down"
                  :class="[{ 'submenu-icon-arrow': childCoursePopoverShow }]"
                ></i
              ></span>
            </div>
            <el-checkbox-group v-model="childCourseStatusLabelList">
              <el-checkbox
                v-for="(item, index) in childCourseStatusList"
                :label="item.name"
                :key="index"
              ></el-checkbox>
            </el-checkbox-group>
            <div class="popover-footer">
              <el-button
                type="text"
                size="small"
                class="clear-bt"
                @click="clearFilterLabel(3)"
                >Clear All</el-button
              >
              <el-button
                size="small"
                class="apply-bt"
                @click.stop="applyFilter(3)"
                >Apply</el-button
              >
            </div>
          </el-popover>
          <el-popover
            placement="bottom-start"
            width="220"
            trigger="click"
            v-model="commentStatusPopoverShow"
            popper-class="pc-filter-popover"
          >
            <div
              class="filter-btn-box"
              :class="{ 'select-filter': commentStatusLabelList.length > 0 }"
              slot="reference"
            >
              Comment Status<span class="arrow-box"
                ><i
                  class="el-icon-arrow-down"
                  :class="[{ 'submenu-icon-arrow': commentStatusPopoverShow }]"
                ></i
              ></span>
            </div>
            <el-checkbox-group v-model="commentStatusLabelList">
              <el-checkbox
                v-for="(item, index) in commentStatusList"
                :label="item.name"
                :key="index"
              ></el-checkbox>
            </el-checkbox-group>
            <div class="popover-footer">
              <el-button
                type="text"
                size="small"
                class="clear-bt"
                @click="clearFilterLabel(4)"
                >Clear All</el-button
              >
              <el-button
                size="small"
                class="apply-bt"
                @click.stop="applyFilter(4)"
                >Apply</el-button
              >
            </div>
          </el-popover>
          <el-popover
            placement="bottom-start"
            width="220"
            trigger="click"
            v-model="complainStatusPopoverShow"
            popper-class="pc-filter-popover"
          >
            <div
              class="filter-btn-box"
              :class="{ 'select-filter': complainStatusLabelList.length > 0 }"
              slot="reference"
            >
              Complain Status<span class="arrow-box"
                ><i
                  class="el-icon-arrow-down"
                  :class="[{ 'submenu-icon-arrow': complainStatusPopoverShow }]"
                ></i
              ></span>
            </div>
            <el-checkbox-group v-model="complainStatusLabelList">
              <el-checkbox
                v-for="(item, index) in complainStatusList"
                :label="item.name"
                :key="index"
              ></el-checkbox>
            </el-checkbox-group>
            <div class="popover-footer">
              <el-button
                type="text"
                size="small"
                class="clear-bt"
                @click="clearFilterLabel(5)"
                >Clear All</el-button
              >
              <el-button
                size="small"
                class="apply-bt"
                @click.stop="applyFilter(5)"
                >Apply</el-button
              >
            </div>
          </el-popover>
        </div>
        <div class="search-box-reset-box">
          <el-button class="reset-bt" size="small" @click="resetFilter(2)"
            >Reset</el-button
          >
        </div>
      </div>

      <div class="search-box-li" v-if="showChildFilterLabels">
        <div
          class="filters-wrapper"
          v-for="(item, index) in childCourseStatusLabelList"
          :key="index"
        >
          {{ item }}
        </div>
        <div
          class="filters-wrapper"
          v-for="(item, index) in commentStatusLabelList"
          :key="'comment' + index"
        >
          {{ item }}
        </div>
        <div
          class="filters-wrapper"
          v-for="(item, index) in complainStatusLabelList"
          :key="'complain' + index"
        >
          {{ item }}
        </div>
      </div>
    </div>
    <!-- 展示一节课下的每一次课 -->
    <div class="teach-course-information" v-if="courseInformationVisible">
      <div class="list-head">
        <div class="flex_2">Session</div>
        <!-- <div class="flex_2">Course</div> -->
        <div class="flex_3">Student</div>
        <div class="flex_3">Room</div>
        <div class="flex_3">Status</div>
        <div class="flex_3">Club</div>

        <div class="flex_3">Time</div>
        <div class="flex_3">Operation</div>
      </div>
      <div
        class="list-content"
        v-for="(item, index) of teachLessonList"
        :key="index"
      >
        <div class="flex_2">{{ item.id }}</div>
        <!-- <div class="flex_2 limit-length" :title="item.covey_course.courseName">{{item.covey_course.courseName}}</div> -->
        <div class="flex_3 limit-length">
          {{ item.covey_user ? item.covey_user.realname : "" }}
        </div>
        <div class="flex_3">
          <div>
            site:
            <a
              class="room_site"
              v-if="item.roomsite"
              :href="item.roomsite"
              target="_blank"
              >Go to the site</a
            >
          </div>
          <div>code: {{ item.roomcode }}</div>
        </div>
        <div class="flex_3 flex-box">
          <i
            style="margin-right: 8px"
            :class="lessonMap[item.status].icon"
            :style="{ color: lessonMap[item.status].color }"
          ></i>
          <span>{{ lessonMap[item.status].name }}</span>
        </div>

        <div class="flex_3">
          <div v-if="item.covey_group">
            <div>{{ item.covey_group.societyName }}</div>
            <div>Proportion:{{ item.proportion }}%</div>
          </div>
        </div>

        <div class="flex_3">
          {{
            format(item.apdate, "MMM. Do") +
            " " +
            item.starttime +
            "-" +
            item.endtime
          }}
        </div>

        <div class="flex_3 operation">
          <div>
            <span
              v-if="[0, 1].includes(item.status)"
              @click="openCourseAddressDialog(item)"
              >Course address</span
            >
          </div>
          <div>
            <span v-if="item.status === 0" @click="handleDeleteClass(item)"
              >Delete Class</span
            >
          </div>
        </div>
      </div>

      <div v-if="teachLessonList.length < 5">
        <div
          class="list-content"
          v-for="index in 5 - teachLessonList.length"
          :key="index"
        ></div>
      </div>
    </div>
    <KtPag
      v-if="!courseInformationVisible"
      style="text-align: right"
      :pageCount="courseInfoParams.count"
      :currentPage="courseInfoParams.page"
      :limit="courseInfoParams.limit"
      @onChange="onCourseInfoPageChange"
    ></KtPag>

    <KtPag
      v-if="courseInformationVisible"
      style="text-align: right"
      :pageCount="lessonInfoParams.count"
      :currentPage="lessonInfoParams.page"
      :limit="lessonInfoParams.limit"
      @onChange="onLessonInfoPageChange"
    ></KtPag>

    <el-dialog
      custom-class="course-address-dialog"
      :visible.sync="courseAddressDialog"
      :append-to-body="true"
      title="Course address"
    >
      <div class="form-item">
        <label class="form-title">Copy course link: </label>
        <div class="form-content">
          <el-input
            v-model="courseAddressForm.roomsite"
            class="input-link"
            placeholder="Copy course link"
          ></el-input>
        </div>
      </div>
      <div class="form-item">
        <label class="form-title">Course code: </label>
        <div class="form-content">
          <el-input
            style="width: 40%"
            v-model="courseAddressForm.roomcode"
            placeholder="Course code"
          ></el-input>
        </div>
      </div>

      <div class="box-foot">
        <div class="my-button cancel" @click="courseAddressDialog = false">
          CANCEL
        </div>
        <div
          class="my-button"
          @click="handleUpdateRoom"
          v-loading="updateRoomLoading"
        >
          SURE
        </div>
      </div>
    </el-dialog>

    <el-dialog
      custom-class="publish-courses-dialog"
      style="height: 100%"
      width="80%"
      :visible.sync="publishCourseDialog"
      :append-to-body="true"
      title="Publish courses"
    >
      <el-form label-width="200px" label-position="left">
        <div class="main-title">Pricing and Packaging</div>
        <el-form-item label="Regular Price">
          C$
          <el-input-number
            v-model="rePublishCourse.price"
            style="width: 10%"
            class="number-input"
            :controls="false"
            :precision="2"
          >
          </el-input-number>
          / Session (1 hour)
        </el-form-item>
        <el-form-item label="Bundle Options">
          <div
            v-for="(item, index) in rePublishCourse.prices"
            :key="index"
            style="margin-bottom: 24px"
          >
            <el-input-number
              type="number"
              :controls="false"
              :precision="0"
              style="width: 20%"
              v-model="item.book_amount"
              class="number-input"
              :min="minLesson(index)"
            ></el-input-number>
            Lesson
            <el-input-number
              type="number"
              :controls="false"
              :precision="2"
              style="width: 20%"
              v-model="item.price"
              class="number-input"
            ></el-input-number>
            / Session (1 hour)
            <i
              style="
                color: #f48c06;
                font-size: 16px;
                margin-left: 18px;
                cursor: pointer;
              "
              class="el-icon-delete"
              @click="deleteBundleOptions(index)"
            ></i>
          </div>
          <div
            class="icon-gray-button"
            style="width: 40%"
            @click="addBundleOptions"
          >
            <div>
              <img :src="require('@/assets/icon/coupon.png')" />
              <span>Add Bundle Options</span>
            </div>
            <i class="el-icon-circle-plus"></i>
          </div>
        </el-form-item>

        <el-form-item prop="groupId">
          <el-checkbox
            slot="label"
            v-model="rePublishCourse.isTeachingForAclub"
            @change="onTeachingForAclub"
            >Teaching for a club</el-checkbox
          >
          <el-select
            v-model="rePublishCourse.groupId"
            v-if="rePublishCourse.isTeachingForAclub"
            placeholder="Club"
          >
            <el-option
              v-for="(item, index) in getshortgroupList"
              :key="index"
              :value="item.covey_group.id"
              :label="item.covey_group.societyName"
              >{{ item.covey_group.societyName }}</el-option
            >
          </el-select>
          <span v-if="rePublishCourse.isTeachingForAclub">
            Share
            <el-input-number
              v-model="rePublishCourse.proportion"
              controls-position="right"
              :min="0"
              :max="100"
            ></el-input-number>
            % proportion for Club
          </span>
        </el-form-item>

        <ScheduleTable
          v-if="publishCourseDialog"
          ref="ScheduleTable"
          :highlightTable="highlightTable"
        ></ScheduleTable>
      </el-form>

      <div class="box-foot">
        <div class="my-button cancel" @click="publishCourseDialog = false">
          CANCEL
        </div>
        <div class="my-button" @click="handleUpdateSchedule">SURE</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { format, validateObjAllProp, determineArrOrder } from "@/utils/comm";
import _ from "lodash";
import ScheduleTable from "@/views/Pc/Component/ScheduleTable";
import KtPag from "@/views/Comm/KtPag";
export default {
  components: {
    ScheduleTable,
    KtPag,
  },
  computed: {
    showFilterLabels() {
      return this.courseStatusLabelList.length > 0;
    },
    showChildFilterLabels() {
      return (
        this.childCourseStatusList.length > 0 ||
        this.commentStatusLabelList.length > 0 ||
        this.complainStatusLabelList.length > 0
      );
    },
  },
  mounted() {},
  data() {
    return {
      queryStr: "",
      teacherCourseList: [],
      teachLessonList: [], //子课程
      format: format,
      statusMap: {
        "-1": { name: "el-icon-remove", color: "#7E8088" },
        0: { name: "el-icon-loading", color: "#f48c06" },
        1: { name: "el-icon-success", color: "#3BB20A" },
        2: { name: "el-icon-error", color: "#f56c6c" },
        3: { name: "el-icon-error", color: "#f56c6c" },
        4: { name: "el-icon-error", color: "#f56c6c" },
        5: { name: "el-icon-success", color: "#3BB20A" },
      },
      statusStrMap: {
        "-1": { name: "Draft", icon: "el-icon-remove", color: "#7E8088" },
        0: { name: "Under review", icon: "el-icon-remove", color: "#409eff" },
        1: { name: "Passed", icon: "el-icon-success", color: "#3BB20A" },
        2: { name: "Reject", icon: "el-icon-remove", color: "#f56c6c" },
      },
      lessonMap: {
        "-1": { name: "Invalid", icon: "el-icon-error", color: "#7E8088" }, //无效
        0: { name: "No appointment", icon: "el-icon-remove", color: "#409eff" }, //待预约
        1: { name: "Booked", icon: "el-icon-circle-check", color: "#67c23a" }, //预约成功
        2: { name: "Canceled", icon: "el-icon-remove", color: "#e6a23c" },
        3: {
          name: "Agree to cancel",
          icon: "el-icon-remove",
          color: "#409eff",
        },
        4: {
          name: "Refuse to cancel",
          icon: "el-icon-remove",
          color: "#409eff",
        },
        5: {
          name: "Course completed",
          icon: "el-icon-success",
          color: "#67c23a",
        },
      },

      courseInformationVisible: false,
      courseAddressDialog: false, //课程详情中的课程地址
      publishCourseDialog: false, //发布课程次数相关
      updateRoomLoading: false,
      courseAddressForm: {
        roomsite: "",
        roomcode: "",
        id: "",
      },
      rePublishCourse: {
        price: 0.0,
        courseId: "",
        prices: [],
        isTeachingForAclub: false,
        proportion: 50,
        groupId: "",
      },
      highlightTable: [],
      courseInfoParams: {
        page: 1,
        count: 0,
        limit: 10,
      },
      lessonInfoParams: {
        // page:1,
        count: 0,
        // limit:10
      },
      getshortgroupList: [], //社团
      courseStatusList: [
        { name: "Draft", status: -1 },
        { name: "Under review", status: 0 },
        { name: "Passed", status: 1 },
        { name: "Reject", status: 2 },
      ],
      courseStatusLabelList: [],
      coursePopoverShow: false,
      childCourseStatusList: [
        { name: "No appointment", status: 0 }, //待预约
        { name: "Booked", status: 1 }, //预约成功
        { name: "Canceled", status: 2 },
        {
          name: "Agree to cancel",
          status: 3,
        },
        {
          name: "Refuse to cancel",
          status: 4,
        },
        {
          name: "Course completed",
          status: 5,
        },
      ],
      childCourseStatusLabelList: [],
      childCoursePopoverShow: false,
      commentStatusList: [
        //子订单的评论状态
        { name: "Not evaluated", status: 0 },
        { name: "Evaluated", status: 1 },
        { name: "Auto", status: 2 },
      ],
      commentStatusLabelList: [],
      commentStatusPopoverShow: false,
      complainStatusList: [
        //投诉状态
        { name: "No supporting case filed", status: 0 },
        { name: "Supporting case in progress", status: 1 },
        { name: "Supporting case solved", status: 2 },
        { name: "Case failed", status: 3 },
      ],
      complainStatusLabelList: [],
      complainStatusPopoverShow: false,
    };
  },
  watch: {
    "$route.query": function (newVal, oldVal) {
      this.initPage();
    },
  },
  created() {
    this.initPage();
  },
  methods: {
    minLesson(index) {
      if (this.rePublishCourse.prices[index - 1]) {
        return this.rePublishCourse.prices[index - 1].book_amount + 1;
      } else {
        return 2;
      }
    },
    initPage() {
      if (this.$route.query && this.$route.query.courseId) {
        this.courseInformationVisible = true;
        this.getTeachLessonList(1);
      } else {
        this.courseInformationVisible = false;
        this.getCourseList(1);
      }
    },
    search() {
      this.courseInfoParams["searchcourse"] = this.queryStr;
      this.getCourseList(1);
    },
    gotoAddCourse() {
      let routeData = this.$router.resolve({
        path: "/teach/publishcourse",
      });
      window.open(routeData.href, "_blank");
      // this.$router.push('/page/')
    },
    onCourseInfoPageChange({ page, limit }) {
      this.courseInfoParams.page = page;
      this.courseInfoParams.limit = limit;
      this.getCourseList(2);
    },
    //我的课程
    getCourseList(type) {
      if (type === 1) {
        this.courseInfoParams.page = 1;
      }
      let params = { ...this.courseInfoParams };
      if (this.courseStatusLabelList.length > 0) {
        params["status"] = this.courseStatusList
          .map((item) => {
            for (let label of this.courseStatusLabelList) {
              if (label === item.name) {
                return item.status;
              }
            }
          })
          .filter((item) => item !== "" && item !== null && item !== undefined);
      }
      delete params.count;
      this.$api.courseApi.getTeacherCourseList(params).then((res) => {
        if (res.status === "0") {
          res.data.rows.forEach((item) => {
            item.courseImg = JSON.parse(item.courseImg || "[]");
          });
          this.teacherCourseList = res.data.rows;
          this.courseInfoParams.count = res.data.count;
        }
      });
    },
    onLessonInfoPageChange({ page, limit }) {
      this.lessonInfoParams.page = page;
      this.lessonInfoParams.limit = limit;
      this.getTeachLessonList(2);
    },
    // 我的课程-上课-子课程
    getTeachLessonList(type) {
      if (type === 1) {
        this.lessonInfoParams.page = 1;
      }
      let params = { ...this.lessonInfoParams };
      params.courseId = this.$route.query.courseId;
      if (this.childCourseStatusLabelList.length > 0) {
        params["status"] = this.childCourseStatusList
          .map((item) => {
            for (let label of this.childCourseStatusLabelList) {
              if (label === item.name) {
                return item.status;
              }
            }
          })
          .filter((item) => item !== "" && item !== null && item !== undefined);
      }
      if (this.commentStatusLabelList.length > 0) {
        params["commentstatus"] = this.commentStatusList
          .map((item) => {
            for (let label of this.commentStatusLabelList) {
              if (label === item.name) {
                return item.status;
              }
            }
          })
          .filter((item) => item !== "" && item !== null && item !== undefined);
      }
      if (this.complainStatusLabelList.length > 0) {
        params["complainstatus"] = this.complainStatusList
          .map((item) => {
            for (let label of this.complainStatusLabelList) {
              if (label === item.name) {
                return item.status;
              }
            }
          })
          .filter((item) => item !== "" && item !== null && item !== undefined);
      }
      delete params.count;
      this.$api.courseApi.getTeachLessons(params).then((res) => {
        if (res.status === "0") {
          this.teachLessonList = res.data.rows;
          this.lessonInfoParams.count = res.data.count;
        }
      });
    },

    teachCourse(item) {
      this.$router.push({
        path: this.$route.path,
        query: {
          courseId: item.id,
        },
      });
    },
    validateNumber(val) {
      if (typeof val === "number" && !isNaN(val) && val > 0) {
        return true;
      } else {
        return false;
      }
    },

    //重新发布课程的时间、价格等
    publishCourse(item) {
      this.publishCourseDialog = true;
      this.$api.courseApi.getTeachLessons({ courseId: item.id }).then((res) => {
        if (res.status === "0") {
          this.highlightTable = res.data.rows;
        }
      });
      this.rePublishCourse.courseId = item.id;
      this.getCoursePrice(item.id);
    },
    //编辑课程，跳转到发布课程页面
    editCourse(item) {
      this.$router.push({
        path: "/teach/publishcourse",
        query: {
          draftId: item.id,
        },
      });
    },
    //重新发布课程时 获取该课程的价格信息
    getCoursePrice(courseId) {
      this.$api.courseApi.getCoursePrice({ courseId: courseId }).then((res) => {
        if (res.status === "0") {
          if (Array.isArray(res.data) && res.data.length > 0) {
            this.rePublishCourse.price = (res.data[0].price / 100).toFixed(2);
          } else {
            this.rePublishCourse.price = 0;
          }
          let tempData = [...res.data];
          tempData.shift();
          for (let item of tempData) {
            item.price = (item.price / 100).toFixed(2);
          }
          this.rePublishCourse.prices = tempData;
        } else {
          this.$message.error("Error!" + res.message);
        }
      });
    },
    //打开地址
    openCourseAddressDialog(item) {
      this.courseAddressForm.roomcode = item.roomcode || "";
      this.courseAddressForm.roomsite = item.roomsite || "";
      this.courseAddressForm.id = item.id;
      this.courseAddressDialog = true;
    },
    //删除子课程
    handleDeleteClass(item) {
      this.$confirm(`Are you sure you want to delete this sub-course?`, "", {
        confirmButtonText: "Sure",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(async () => {
          this.$api.orderApi.deleteCourseTime({ id: item.id }).then((res) => {
            if (res.status === "0") {
              this.$message.success(res.message);
              this.getTeachLessonList(1);
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //更新上课url
    handleUpdateRoom() {
      let params = { ...this.courseAddressForm };
      if (!(params.roomsite || params.roomcode)) {
        return;
      }

      this.updateRoomLoading = true;
      this.$api.courseApi.updateCourseCalendar(params).then((res) => {
        if (res.status === "0") {
          this.getTeachLessonList(1);
          this.courseAddressDialog = false;
          this.$message.success("Success!");
        } else {
          this.$message.error("Error! Reason:" + res.message);
        }
        this.updateRoomLoading = false;
      });
    },
    //添加一条记录
    addBundleOptions() {
      this.rePublishCourse.prices.push({
        book_amount: 0,
        price: 0,
      });
    },
    //删除一条记录
    deleteBundleOptions(index) {
      this.rePublishCourse.prices.splice(index, 1);
    },

    // 获取社团列表
    getshortgroup() {
      this.$api.courseApi.getshortgroup().then((res) => {
        if (res.status === "0") {
          this.getshortgroupList = res.data.rows;
          if (Array.isArray(res.data.rows) && res.data.rows.length === 0) {
            //todo 未加入社团的情况
            this.$message.warning("Not yet joined the club");
            this.rePublishCourse.isTeachingForAclub = false;
          }
        }
      });
    },
    onTeachingForAclub(val) {
      if (val) {
        this.rePublishCourse.groupId = "";
        this.getshortgroup();
      }
    },
    validateNumber(val) {
      if (typeof val === "number" && !isNaN(val) && val > 0) {
        return true;
      } else {
        return false;
      }
    },
    //同一课程添加上课时间
    handleUpdateSchedule() {
      let params = _.cloneDeep(this.rePublishCourse);
      let calendars = this.$refs["ScheduleTable"].tempSchedule;
      // if(calendars.length<=0){
      //     return
      // }
      params.prices.unshift({
        book_amount: 1,
        price: this.rePublishCourse.price,
      });
      if (params.prices.length < 1) {
        this.$message.warning(
          "Please fill at least one correct amount and one price in Bundle Options"
        );
        return;
      }
      for (let priceItem of params.prices) {
        if (
          !this.validateNumber(priceItem.book_amount) ||
          !this.validateNumber(priceItem.price)
        ) {
          this.$message.warning(
            "Please fill in the correct amount and price in Bundle Options"
          );
          return;
        } else {
          priceItem["price"] = priceItem.price * 100;
        }
      }
      //prices 有两项
      if (params.prices.length >= 2) {
        let bookAmountArr = params.prices.map((item) => item.book_amount);
        let priceArr = params.prices.map((item) => item.price);
        if (
          determineArrOrder(bookAmountArr) !== "ascending" ||
          determineArrOrder(priceArr) !== "descending"
        ) {
          this.$message.warning(
            "Amoun must increase, price must decrease in Bundle Options"
          );
          return;
        }
      }
      //   params.prices.forEach((item) => {
      //     t_prices.push({
      //       book_amount: item.book_amount,
      //       price: item.price * 100,
      //     });
      //   });
      params.calendars = calendars;

      //处理社团
      if (!params.isTeachingForAclub) {
        params.groupId = 0;
        params.proportion = 0;
      }
      delete params.isTeachingForAclub;
      this.$api.courseApi.issueCourseCalendar(params).then((res) => {
        if (res.status === "0") {
          this.publishCourseDialog = false;
          this.$message.success(res.message);
        } else {
          this.$message.error("Error! Reason:" + res.message);
        }
      });
    },
    clearFilterLabel(type) {
      if (type === 1) {
        this.courseStatusLabelList = [];
      } else if (type === 3) {
        this.childCourseStatusLabelList = [];
      } else if (type === 4) {
        this.commentStatusLabelList = [];
      } else if (type === 5) {
        this.complainStatusLabelList = [];
      }
    },
    applyFilter(type) {
      if (type === 1) {
        this.getCourseList(1);
        this.coursePopoverShow = false;
      } else if (type === 3) {
        this.getTeachLessonList(1);
        this.childCoursePopoverShow = false;
      } else if (type === 4) {
        this.getTeachLessonList(1);
        this.commentStatusPopoverShow = false;
      } else if (type === 5) {
        this.getTeachLessonList(1);
        this.complainStatusPopoverShow = false;
      }
    },
    resetFilter(type) {
      if (type === 1) {
        this.courseStatusLabelList = [];
        this.getCourseList(1);
      } else if (type === 2) {
        this.childCourseStatusLabelList = [];
        this.commentStatusLabelList = [];
        this.complainStatusLabelList = [];
        this.getTeachLessonList(1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.myinfo-course-box {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  .search-box-1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .search-box-2 {
    margin-top: 0 !important;
  }
  .search-box {
    box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    background: #ffffff;
    padding: 12px 24px;
    margin: 24px 0;
    box-sizing: border-box;
    .search-box-fliter-box {
      display: flex;
      justify-content: space-between;
      .search-box-fliter {
        display: flex;
      }
      .search-box-reset-box {
        .reset-bt {
          font-size: 14px;
        }
      }
    }
    .select-filter {
      color: #f48c06 !important;
      border-color: #f8d19e !important;
      background-color: #ffffff !important;
    }
    .filter-btn-box {
      font-weight: 600;
      color: #7e8088;
      min-width: 50px;
      padding: 6px 12px;
      border-radius: 4px;
      border: 1px solid #dadbdd;
      margin-right: 12px;
      box-sizing: border-box;
      cursor: pointer;
      &:hover {
        color: #f48c06;
        border-color: #f8d19e;
        background-color: #ffffff;
      }
      .arrow-box {
        margin-left: 6px;
        i {
          transition: all 500ms;
          font-size: 12px;
          &:hover {
            color: #f48c06;
            border-color: #f8d19e;
            background-color: #ffffff;
          }
        }
      }
      .submenu-icon-arrow {
        transform: rotate(180deg);
      }
    }
    .reset-bt {
      font-size: 14px;
      color: #7e8088;
      &:hover {
        color: #f48c06;
        border-color: #f8d19e;
        background-color: #ffffff;
      }
    }
  }
  .search-box-li {
    // height: 35px;
    // padding: 6px 0;
    margin-top: 12px;
    display: flex;
    flex-wrap: wrap;
    .filters-wrapper {
      color: #7e8088;
      font-size: 14px;
      // line-height: 22px;
      font-weight: 600;
      background-color: #efeff0;
      margin: 0 10px 10px 0;
      padding: 3px 12px;
      // border: none;
      border-radius: 50px;
      box-sizing: border-box;
    }
  }
  .flex_1,
  .flex_2,
  .flex_3,
  .flex_4,
  .flex_5,
  .flex_6,
  .flex_7 {
    padding: 0 6px;
    align-self: center;
  }
  .flex_1 {
    flex: 1;
  }
  .flex_2 {
    flex: 2;
  }
  .flex_3 {
    flex: 3;
  }
  .flex_4 {
    flex: 4;
  }
  .flex_5 {
    flex: 5;
  }
  .flex_6 {
    flex: 6;
  }
  .flex_7 {
    flex: 7;
  }

  .operation {
    span {
      padding: 2px 4px;
      color: #f48c06;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .flex-box {
    display: flex;
    height: 100%;
    align-items: center;
  }
  .info-box {
    height: 100%;
  }

  //限制长度
  .limit-length {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .info-detail {
    width: calc(100% - 128px);
    display: inline-block;
    vertical-align: top;
    word-break: break-word;
    .detail-title {
      font-size: 18px;
      font-weight: 500;
      color: #201002;
      line-height: 24px;

      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .detail-content {
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      margin-top: 6px;
    }
    .detail-id {
      font-size: 14px;
      color: #b7b2ae;
      line-height: 20px;
      // margin-top: 6px;
    }
  }

  .icon-gray-button {
    width: vw(276);
    height: 48px;
    line-height: vw(48);
    box-sizing: border-box;
    padding: 14px;
    background: rgba(32, 16, 2, 0.04);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    div {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    span {
      margin-left: 4px;
      font-size: 14px;
      font-weight: 600;
      color: #201002;
      line-height: 20px;
    }
    i {
      float: right;
    }
  }
  .search {
    width: 422px;
    height: 48px;
    background: #ffffff;
    border-radius: 8px;
    padding: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    box-sizing: border-box;
    img {
      margin-left: 8px;
      margin-right: 15px;
    }
    .el-button {
      background: #f48c06;
      height: 36px;
      border-radius: 8px;
      padding: 12px;
      border: none;
      color: #ffffff;
      font-weight: 600;
      font-size: 16px;
      display: flex;
      align-items: center;
    }
    .el-input__inner {
      border: none;
    }
    /deep/ .el-input__inner {
      border: none;
      font-size: vw(18);
      color: #464646;
      line-height: vw(38);
      height: 100%;
    }
  }

  .myinfo-mid-content {
    margin-top: vw(32);
    box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    background: #ffffff;
    .list-head,
    .list-content {
      display: flex;
      padding: 12px 24px;
      box-sizing: border-box;
    }
    .list-head {
      min-height: 73px;
      height: vw(73);
      font-size: 18px;
      color: #201002;
    }
    .list-content {
      height: 104px;
      border-top: 1px solid #dbd9d6;
      font-size: 14px;
      .info-img {
        width: 120px;
        height: 72px;
        border-radius: 2px;
        display: inline-block;
        vertical-align: top;
      }
    }
  }

  .teach-course-information {
    box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
    border-radius: 8px;
    background: #ffffff;
    .search-box {
      margin-bottom: 24px !important;
      margin-top: 0 !important;
    }
    .list-head,
    .list-content {
      display: flex;
      padding: vw(24) vw(32);
      box-sizing: border-box;
    }
    .list-head {
      min-height: 72px;
      height: vw(72);
      font-size: 18px;
      color: #201002;
    }
    .list-content {
      min-height: 72px;
      height: vw(72);
      border-top: 1px solid #dbd9d6;
      font-size: 14px;
      .operation {
        span {
          color: #f48c06;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
  .room_site {
    text-decoration: none;
    color: #f48c06;
    &:hover {
      text-decoration: underline;
    }
  }
}

.box-foot {
  margin-top: 46px;
  display: flex;
  justify-content: center;
  font-size: 14px;
}
.my-button {
  cursor: pointer;
  width: 120px;
  height: 48px;
  background: #f48c06;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  span {
    font-size: 14px;
    color: #ffffff;
    line-height: 20px;
  }
}
.cancel {
  margin-right: 24px;
  background: #f2f2f2;
  color: #201002;
}
</style>
